import { render, staticRenderFns } from "./PropertyBuildingEditor.vue?vue&type=template&id=569e1f94&scoped=true&lang=pug&"
import script from "./PropertyBuildingEditor.vue?vue&type=script&lang=ts&"
export * from "./PropertyBuildingEditor.vue?vue&type=script&lang=ts&"
import style0 from "./PropertyBuildingEditor.vue?vue&type=style&index=0&id=569e1f94&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "569e1f94",
  null
  
)

export default component.exports